import { resolveKnobPadding } from './properties/v2/padding.js';

function finiteNumber(value, fallback = 0) {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
}

/**
 * Resolve Switch knob pads using the shared legacy compatibility rule. Direct
 * pad_* values are raw LVGL values; legacy knob.padding is total extra size.
 */
export function resolveSwitchKnobPadding(style = {}) {
    return resolveKnobPadding(style);
}

/**
 * LVGL 7 switch geometry is intentionally different from slider geometry:
 * the unpadded knob is a square as tall as the switch and its x anchor is
 * either 0 (off) or width - height (on). LVGL expands that base area by the
 * knob's four per-side pads afterwards.
 */
export function switchKnobBounds({ value = 0, width, height, ...pads }) {
    const baseSize = Math.max(0, finiteNumber(height));
    const trackWidth = Math.max(0, finiteNumber(width));
    const anchor = finiteNumber(value) > 0 ? trackWidth - baseSize : 0;
    const left = finiteNumber(pads.left);
    const right = finiteNumber(pads.right);
    const top = finiteNumber(pads.top);
    const bottom = finiteNumber(pads.bottom);
    return {
        x: anchor - left,
        y: top === 0 ? 0 : -top,
        width: baseSize + left + right,
        height: baseSize + top + bottom,
    };
}

/** Convert a dragged Konva knob position to Switch's binary value. */
export function switchValueFromBounds({ x = 0, width, height, ...pads }) {
    const baseSize = Math.max(0, finiteNumber(height));
    const trackWidth = Math.max(0, finiteNumber(width));
    const left = finiteNumber(pads.left);
    const anchor = finiteNumber(x) + left;
    return anchor >= (trackWidth - baseSize) / 2 ? 1 : 0;
}
